import React, {Component} from 'react';
import './main.scss'
import data from './data.json'

const colors = [
  "red", "purple", "orange", "green", "teal"
]

class App extends Component {
  constructor(props){
    super(props)

    this.state = {
      txt: data[0].Copy,
      pic: require('./images/challenge.png'),
      colr: "red"
    }

    this.randomer = this.randomer.bind(this)
  }

  randomer(){
    var randomText = data[Math.floor(Math.random()*data.length)]
    var randomCol = colors[Math.floor(Math.random()*colors.length)]

    this.setState({
      txt: randomText.Copy,
      pic: require('./images/'+ randomText.Image.toLowerCase() +'.png'),
      colr: randomCol
    })

  }

  render() {
    return (
      <div className={"wrapper " + this.state.colr} onClick={() => this.randomer()}>
        <div className={"wrapper-inner " + this.state.colr}>
  
          <div className="txt">
            <p>
              {this.state.txt}
            </p>
          </div>
  
          <div className="pic">
            <img src={this.state.pic} alt="pic" width="100%" />
          </div>

          <div className="blurb">
            <p>Not your cup of tea? <br/>Tap to refresh</p>
          </div>
        </div>
      </div>
    );
  }
}

export default App;
